import React from "react";
import "./Dashboard.css";
import DijonCard from "./DijonCard";
import StrategyPage from "../Strategy/StrategyPage";

function DijonStrategy(props) {
  return (
    <div id="strategy-card">
      <DijonCard
        width={"90vw"}
        height={"90vh"}
        defaultX={0}
        activeCards={props.activeCards}
        setActiveCards={props.setActiveCards}
        name={"strategy"}
        content={
          <div style={{ height: "100%", width: "100%", overflow: "auto", position: "relative", background: "#141414" }}>
            <StrategyPage />
          </div>
        }
      />
    </div>
  );
}

export default DijonStrategy;
